/*
  ============================================================================
  assets/bundle-buy-box.js — the bundle buy box's behaviour (wi-2026-0939,
  lego L213 v2, D-078). Loaded ONLY by snippets/bundle-buy-box-options.liquid,
  which sections/pdp-buy-box.liquid renders only when `bundle_mode` is on.

  WHY A SEPARATE SCRIPT: the family buy box's own script prices the subscribe
  row from selling_plan_allocations on /products/<handle>.js, and a Plan A
  bundle carries NO selling plan (by design, EX-005/EX-007), so that script
  would find nothing, blank data-selling-plan and add the bundle one-time even
  with Subscribe checked. The section therefore marks its bundle-mode root
  data-wired="1" in the markup, the family script skips it, and this file
  wires it instead. Same hooks, same sync() shape (D-054: called at wiring
  time because Subscribe starts checked), same two-call measurement contract.

  THE RAIL: the subscription price and the saving are written here, after
  load; no percentage is ever produced.

  THE STICKY BAR (sections/pdp-sticky-atc.liquid, not edited here) adds a
  single variant with data-selling-plan, which cannot subscribe a Plan A
  bundle. When its plan is Subscribe, a capture-phase listener runs Plan A in
  its place with bundle_src "pdp_sticky" (its own surface value). One-time
  from the sticky is left to the sticky, which already does the right thing.

  Theme-editor lifecycle: idempotent (dataset.bundleWired), re-runs on
  shopify:section:load.
  ============================================================================
*/
(function () {
  if (window.__omBundleBuyBox) return;
  window.__omBundleBuyBox = true;

  // Same pattern the family buy box and assets/door-body.js use to open the drawer.
  function openDrawer() {
    if (window.PUB_SUB_EVENTS && typeof window.publish === 'function') {
      window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'pdp-buy-box' });
      return;
    }
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.reload === 'function') drawer.reload().then(function () { drawer.open(); });
  }

  // Currency formatting taken from the page's own money string (never a hardcoded '$').
  function money(cents, sample) {
    var m = String(sample || '').match(/^([^\d]*)([\d.,]+)([^\d]*)$/);
    var body = (cents / 100).toFixed(2);
    if (!m) return body;
    if (m[2].indexOf(',') > -1 && m[2].indexOf('.') === -1) body = body.replace('.', ',');
    return m[1] + body + m[3];
  }

  function jsonPost(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { if (!r.ok) return failWith(r, url); return r; });
  }

  // /cart/add.js answers 422 with { message, description }: keep Shopify's own
  // words on the error so the buy box can show them (the B2B refusal was silent).
  var GENERIC = 'Sorry, this could not be added to your cart. Please try again.';
  function failWith(r, url) {
    return r.json().catch(function () { return {}; }).then(function (j) {
      var e = new Error(url + ' -> ' + r.status);
      e.userMessage = (j && (j.description || j.message)) || GENERIC;
      throw e;
    });
  }

  var ROOTS = [];

  function wire(root) {
    if (!root || root.dataset.bundleWired === '1') return;
    var cfgNode = root.querySelector('[data-bundle-pricing]');
    if (!cfgNode) return;
    var cfg;
    try { cfg = JSON.parse(cfgNode.textContent); } catch (e) { return; }
    root.dataset.bundleWired = '1';

    // B2B guard (wi-2026-0939): Shopify refuses any selling plan on a B2B
    // order ("Only one-time purchase is available for B2B orders"), and Plan A
    // is selling-plan lines. window.__omIsB2B (layout/theme.liquid, from
    // customer.b2b?) is true only for a company buyer, so for them this box
    // behaves exactly like a bundle with no Plan A entry: Subscribe hidden,
    // One-time checked, the add is one-time, and the sticky bar's Plan A
    // route below stands down (it tests cfg.plan).
    var B2B = window.__omIsB2B === true;
    if (B2B) cfg.plan = null;

    var slot      = root.querySelector('[data-sub-price-slot]');
    var saving    = root.querySelector('[data-sub-saving-slot]');
    var savingOrd = root.querySelector('[data-sub-saving-order]');
    var oncePrice = root.querySelector('[data-onetime-price]');
    var onceShip  = root.querySelector('[data-onetime-detail]');
    var expressId = root.querySelector('[data-express-variant]');
    var sub       = root.querySelector('[id^="l46-sub-"]');
    var subOpt    = root.querySelector('[data-lp-module="pdp-subscribe-toggle"]');
    var addBtn    = root.querySelector('[data-atc="pdp_main"]');
    var radios    = root.querySelectorAll('input[name^="l46-purchase-"]');
    var once      = null;
    for (var i = 0; i < radios.length; i++) if (radios[i] !== sub) once = radios[i];

    function variantById(id) {
      for (var i = 0; i < cfg.variants.length; i++) if (cfg.variants[i].id === id) return cfg.variants[i];
      return null;
    }
    function currentVariant() {
      var r = root.querySelector('input[name^="l46-size-"]:checked');
      return (r && variantById(Number(r.value))) || cfg.variants[0];
    }
    // The renewal price, in order: the variant's own renewal_total_cents
    // (exact for every size, incl. the FF 60-day) -> the bundle-level
    // renewal_total_cents (mirrors the PRIMARY variant) -> today's
    // derivation, Plan A's order-1 total minus one cent per component line
    // (subscription_rollout.checkout_total), which only ever holds for the
    // PRIMARY variant. Absent both fields (today, pre penny-fix), this
    // reproduces the old figure exactly.
    function renewal(vv) {
      if (vv && vv.renewal != null) return vv.renewal;
      if (vv && vv.primary && cfg.plan && cfg.plan.renewalTotalCents != null) return cfg.plan.renewalTotalCents;
      if (!cfg.plan || !vv || !vv.primary || vv.orderOne == null || !vv.components.length) return null;
      return vv.orderOne - vv.components.length;
    }

    function sync() {
      var vv = currentVariant();
      if (!vv) return;
      if (oncePrice) oncePrice.textContent = vv.priceFormatted;
      if (onceShip)  onceShip.textContent  = vv.onceDetail;
      if (expressId) expressId.value = vv.id;
      if (!slot || !sub) return;
      var price = renewal(vv);
      var on = sub.checked && price != null;
      slot.textContent = '';
      if (on) {
        var p = document.createElement('span');   // first child: the sticky bar reads it
        p.textContent = money(price, vv.priceFormatted);
        slot.appendChild(p);
      }
      slot.hidden = !on;
      var line = '';
      if (on && vv.compSum != null && vv.compSum > price && cfg.savingLine) {
        line = cfg.savingLine
          .replace('{save}', money(vv.compSum - price, vv.priceFormatted))
          .replace('{sum}', money(vv.compSum, vv.priceFormatted));
      }
      if (savingOrd) savingOrd.textContent = line;
      if (saving) saving.hidden = !line;
    }

    // No Plan A entry (or a B2B buyer): the bundle cannot subscribe, so it must not offer it.
    if (!cfg.plan) {
      if (subOpt) { subOpt.hidden = true; subOpt.dataset.sellingPlan = ''; }
      if (sub && B2B) { sub.checked = false; sub.disabled = true; }
      if (once) once.checked = true;
    }

    // The add error line: script-created (first-paint HTML unchanged), inserted
    // before any add so role=alert text written into it is announced.
    var errLine = null;
    if (addBtn) {
      errLine = document.createElement('p');
      errLine.className = 'atc-error om-small';
      errLine.setAttribute('role', 'alert');
      errLine.setAttribute('data-lp', 'atc_error');
      addBtn.insertAdjacentElement('afterend', errLine);
    }
    function showError(msg) { if (errLine) errLine.textContent = msg || ''; }

    // ---- Plan A: EXACTLY bundle-subscribe-toggle's sequence -----------------
    var running = false;
    function planA(vv, src, btn) {
      if (running || !cfg.plan || !vv || !vv.components.length) return false;
      running = true;
      showError('');
      var planId = parseInt(cfg.plan.sellingPlanId, 10);
      var items = vv.components.map(function (c) {
        return { id: c.id, quantity: c.qty || 1, selling_plan: planId };
      });
      if (btn) btn.setAttribute('aria-disabled', 'true');
      // 1) component lines on the plan; 2) the SECOND call, bundle_id +
      // bundle_src (add.js cannot write attributes; dropping it parks the order
      // cm2_unresolved); 3) the discount navigation LAST.
      jsonPost('/cart/add.js', { items: items })
        .then(function () {
          return jsonPost('/cart/update.js', { attributes: { bundle_id: cfg.plan.bundleId, bundle_src: src } });
        })
        .then(function () {
          window.location.href = '/discount/' + encodeURIComponent(cfg.plan.code) + '?redirect=/cart';
        })
        .catch(function (err) {
          running = false;
          showError(err && err.userMessage ? err.userMessage : GENERIC);
          if (btn) btn.removeAttribute('aria-disabled');
        });
      return true;
    }

    // ---- One-time: the family buy box's path, bundle_src "browse" ----------
    function oneTime(vv) {
      addBtn.setAttribute('aria-disabled', 'true');
      showError('');
      var item = { id: vv.id, quantity: 1 };
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          var ig = c && c.attributes && c.attributes.igTestGroups;
          if (ig) item.properties = { _igTestGroups: ig };
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [item] })
          });
        })
        .then(function (r) { if (!r.ok) return failWith(r, '/cart/add.js'); return r.json(); })
        .then(function (added) {
          return jsonPost('/cart/update.js', {
            attributes: { bundle_id: (subOpt && subOpt.dataset.bundleId) || '', bundle_src: 'browse' }
          }).then(function () { return added; });
        })
        .then(function (added) {
          /* add_to_cart tracking: Elevar's automatic cart event is the ONE event (a manual push here double-counted, red team #7); list attribution rides the bundle_src cart attribute. */
          document.dispatchEvent(new CustomEvent('pdp:added', { detail: added }));
          openDrawer();
          addBtn.removeAttribute('aria-disabled');
        })
        .catch(function (err) {
          showError(err && err.userMessage ? err.userMessage : GENERIC);
          addBtn.removeAttribute('aria-disabled');
        });
    }

    root.addEventListener('change', function (e) {
      if (!e.target.matches('input[name^="l46-purchase-"], input[name^="l46-size-"]')) return;
      sync();
    });
    sync();   /* Subscribe is checked in the markup, so this reveals at load */

    if (addBtn) addBtn.addEventListener('click', function () {
      if (addBtn.getAttribute('aria-disabled') === 'true') return;
      var vv = currentVariant();
      if (!vv) return;
      if (sub && sub.checked && cfg.plan) { planA(vv, 'bundle_pdp_subscribe', addBtn); return; }
      oneTime(vv);
    });

    ROOTS.push({ root: root, cfg: cfg, planA: planA, variantById: variantById, currentVariant: currentVariant });
  }

  // ---- The sticky bar's Subscribe add, routed through Plan A ---------------
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-atc="pdp_sticky"]');
    if (!btn || !ROOTS.length) return;
    var box = ROOTS[0];
    if (!box.cfg.plan || !document.body.contains(box.root)) return;
    var bar = btn.closest('.lego-L12-v4') || document;
    var plan = bar.querySelector('input[name^="l12v4-plan-"]:checked');
    if (!plan || plan.value !== 'sub') return;           // one-time: the sticky's own path
    var size = bar.querySelector('input[name^="l12v4-size-"]:checked');
    var vv = (size && box.variantById(Number(size.value))) || box.currentVariant();
    e.preventDefault();
    e.stopImmediatePropagation();
    box.planA(vv, 'pdp_sticky', btn);
  }, true);

  function init(scope) {
    (scope || document).querySelectorAll('[data-bundle-buy-box]').forEach(wire);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); }, { once: true });
  } else { init(document); }
  document.addEventListener('shopify:section:load', function (e) {
    ROOTS = ROOTS.filter(function (b) { return document.body.contains(b.root); });
    init(e.target);
  });
})();
